// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2NccF","colCheckbox":"styles_colCheckbox__3WTPr"};